import * as z from "zod/v4";

export const deleteGuidance = {
  name: "deleteGuidance" as const,
  input: z.object({}),
  output: z.void(),
};
